import {
    GET_INSTITUTES_REQUEST,
    GET_INSTITUTES_SUCCESS,
    GET_INSTITUTES_FAILURE,
    GET_SCHOOLYEARS_REQUEST,
    GET_SCHOOLYEARS_SUCCESS,
    GET_SCHOOLYEARS_FAILURE,
    GET_FEDERALSTATES_REQUEST,
    GET_FEDERALSTATES_SUCCESS,
    GET_FEDERALSTATES_FAILURE,
    GET_CLASSIFICATIONTYPES_REQUEST,
    GET_CLASSIFICATIONTYPES_SUCCESS,
    GET_CLASSIFICATIONTYPES_FAILURE,
    GET_USAGETYPES_REQUEST,
    GET_USAGETYPES_SUCCESS,
    GET_USAGETYPES_FAILURE,
    UPDATE_SCHOOLYEAR_REQUEST,
    UPDATE_SCHOOLYEAR_SUCCESS,
    UPDATE_SCHOOLYEAR_FAILURE,
    GET_NEXTSCHOOLYEAR_REQUEST,
    GET_NEXTSCHOOLYEAR_SUCCESS,
    GET_NEXTSCHOOLYEAR_FAILURE,
    GET_ACTUALSCHOOLYEAR_REQUEST,
    GET_ACTUALSCHOOLYEAR_SUCCESS,
    GET_ACTUALSCHOOLYEAR_FAILURE,
    GET_PREVIOUSSCHOOLYEAR_REQUEST,
    GET_PREVIOUSSCHOOLYEAR_SUCCESS,
    GET_PREVIOUSSCHOOLYEAR_FAILURE
} from "../constants/jointPowersActionTypes";

const initialState = {
    schoolYears: [],
    actualSchoolYear: 0,
    nextSchoolYear: 0,
    previousSchoolYear: 0,
    institutes: [],
    classificationTypes: [],
    federalStates: [],
    usageTypes: [],
    loading: {
        getSchoolYears: false,
        getClassificationTypes: false,
        getFederalStates: false,
        getInstitutes: false,
        getUsageTypes: false,
        updateSchoolYear: false,
        getNextSchoolYear: false,
        getActualSchoolYear: false,
        getPreviousSchoolYear: false
    },
    error: null
}

const jointPowersReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INSTITUTES_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getInstitutes: true },
                error: null
            };
        case GET_INSTITUTES_SUCCESS:
            return {
                ...state,
                institutes: action.payload,
                loading: { ...state.loading, getInstitutes: false },
            };
        case GET_INSTITUTES_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getInstitutes: false },
                error: action.payload
            };
        case GET_SCHOOLYEARS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getSchoolYears: true },
                error: null
            };
        case GET_SCHOOLYEARS_SUCCESS:
            return {
                ...state,
                schoolYears: action.payload,
                loading: { ...state.loading, getSchoolYears: false },
            };
        case GET_SCHOOLYEARS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getSchoolYears: false },
                error: action.payload
            };
        case GET_FEDERALSTATES_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getFederalStates: true },
                error: null
            };
        case GET_FEDERALSTATES_SUCCESS:
            return {
                ...state,
                federalStates: action.payload,
                loading: { ...state.loading, getFederalStates: false },
            };
        case GET_FEDERALSTATES_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getFederalStates: false },
                error: action.payload
            };
        case GET_CLASSIFICATIONTYPES_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getClassificationTypes: true },
                error: null
            };
        case GET_CLASSIFICATIONTYPES_SUCCESS:
            return {
                ...state,
                classificationTypes: action.payload,
                loading: { ...state.loading, getClassificationTypes: false },
            };
        case GET_CLASSIFICATIONTYPES_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getClassificationTypes: false },
                error: action.payload
            };
        case GET_USAGETYPES_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getUsageTypes: true },
                error: null
            };
        case GET_USAGETYPES_SUCCESS:
            return {
                ...state,
                usageTypes: action.payload,
                loading: { ...state.loading, getUsageTypes: false },
            };
        case GET_USAGETYPES_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getUsageTypes: false },
                error: action.payload
            };
        case UPDATE_SCHOOLYEAR_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getUsageTypes: true },
                error: null
            };
        case UPDATE_SCHOOLYEAR_SUCCESS:
            return {
                ...state,
                schoolYears: state.schoolYears.map(schoolYear => schoolYear.ID === action.payload.ID ? action.payload : schoolYear),
                loading: { ...state.loading, updateSchoolYear: false },
            };
        case UPDATE_SCHOOLYEAR_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, updateSchoolYear: false },
                error: action.payload
            };
        case GET_NEXTSCHOOLYEAR_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getNextSchoolYear: true },
                error: null
            };
        case GET_NEXTSCHOOLYEAR_SUCCESS:
            return {
                ...state,
                nextSchoolYear: action.payload,
                loading: { ...state.loading, getNextSchoolYear: false },
            };
        case GET_NEXTSCHOOLYEAR_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getNextSchoolYear: false },
                error: action.payload
            };
        case GET_ACTUALSCHOOLYEAR_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getActualSchoolYear: true },
                error: null
            };
        case GET_ACTUALSCHOOLYEAR_SUCCESS:
            return {
                ...state,
                actualSchoolYear: action.payload,
                loading: { ...state.loading, getActualSchoolYear: false },
            };
        case GET_ACTUALSCHOOLYEAR_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getActualSchoolYear: false },
                error: action.payload
            };
        case GET_PREVIOUSSCHOOLYEAR_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getPreviousSchoolYear: true },
                error: null
            };
        case GET_PREVIOUSSCHOOLYEAR_SUCCESS:
            return {
                ...state,
                previousSchoolYear: action.payload,
                loading: { ...state.loading, getPreviousSchoolYear: false },
            };
        case GET_PREVIOUSSCHOOLYEAR_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getPreviousSchoolYear: false },
                error: action.payload
            };
        default:
            return state;
    }
}

export default jointPowersReducer;